import type { ReactElement, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type PageWrapperProps = {
  children: ReactNode | ReactNode[] | ReactElement | ReactElement[];
  className?: string;
};

export function PageWrapper({ children, className }: PageWrapperProps) {
  return (
    <div
      className={twMerge(
        `mx-auto max-w-[1440px] px-6 pt-6 pb-16 tablet:px-8 laptop:px-8 desktop:px-12`,
        className
      )}
    >
      {children}
    </div>
  );
}
